import { z } from 'zod';

export const fileUploadUiOptionsSchema = z.object({
  acceptedExtensions: z.array(z.string()).optional()
});
